import { render, staticRenderFns } from "./pageMode1.vue?vue&type=template&id=14c5f9f4"
import script from "./pageMode1.vue?vue&type=script&lang=js"
export * from "./pageMode1.vue?vue&type=script&lang=js"
import style0 from "./pageMode1.vue?vue&type=style&index=0&id=14c5f9f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports